const [sm, md, lg] = [768, 992, 1200];

const minWidthMedia = (minWidth: number) => `@media (min-width: ${minWidth}px)`;
const maxWidthMedia = (maxWidth: number) => `@media (max-width: ${maxWidth}px)`;

const media = {
  /** min-width: 1200px */
  lg: minWidthMedia(lg),
  /** min-width: 992px */
  md: minWidthMedia(md),
  /** min-width: 768px */
  sm: minWidthMedia(sm),
  /** print */
  print: '@media print',

  reverse: {
    /** max-width: 1199px */
    lg: maxWidthMedia(lg - 1),
    /** max-width: 991px */
    md: maxWidthMedia(md - 1),
    /** max-width: 767px */
    sm: maxWidthMedia(sm - 1),
  },
};

export default media;
